import { useState } from "react";
import { mediaUrl } from "@/lib/api";


export const Placeholder = ({ label = "Bildplatzhalter", code = "" }) => (
  <div className="flex h-full w-full flex-col items-center justify-center gap-2 bg-paper-subtle ap-grid-bg">
    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#8C9099" strokeWidth="1.2" aria-hidden="true">
      <rect x="2.5" y="4.5" width="19" height="15" />
      <path d="M2.5 15.5 8 10l4.5 4.5L16 11l5.5 5" />
      <circle cx="16.5" cy="8.5" r="1.4" />
    </svg>
    <span className="ap-stamp">{label}</span>
    {code ? <span className="ap-stamp text-[10px]">{code}</span> : null}
  </div>
);

export const Figure = ({ src, mediaId, alt, code, ratio = "aspect-[4/5]", label, variant = "lg", bare = false }) => {
  const [failed, setFailed] = useState(false);
  const resolved = mediaId ? mediaUrl(mediaId, variant) : src;
  return (
    <div className={`relative w-full overflow-hidden ${bare ? "" : "bg-paper-subtle"} ${ratio}`}>
      {resolved && !failed ? (
        <img
          src={resolved}
          alt={alt}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
          className={
            bare
              ? "h-full w-full object-contain"
              : "h-full w-full object-cover transition-transform duration-500 hover:scale-[1.03]"
          }
        />
      ) : (
        <Placeholder label={failed ? "Bild nicht verfügbar" : label || "Bild folgt"} code={code} />
      )}
    </div>
  );
};

export const Corner = () => (
  <>
    <span className="pointer-events-none absolute -left-[1px] -top-[1px] h-3 w-3 border-l border-t border-signal opacity-0 transition-opacity duration-200 group-hover:opacity-100" />
    <span className="pointer-events-none absolute -bottom-[1px] -right-[1px] h-3 w-3 border-b border-r border-signal opacity-0 transition-opacity duration-200 group-hover:opacity-100" />
  </>
);

export const SectionHead = ({ stamp, title, intro, dark = false, id }) => (
  <div className="max-w-3xl">
    {stamp ? <p className="ap-stamp mb-4">{stamp}</p> : null}
    <h2 id={id} className={`ap-h2 ${dark ? "text-paper" : "text-ink"}`}>
      {title}
    </h2>
    {intro ? (
      <p className={`ap-lead mt-5 ${dark ? "text-concrete" : "text-charcoal"}`}>{intro}</p>
    ) : null}
  </div>
);
